import { useState, createContext, useMemo } from "react";

const defaultExpandedAccordions = {
  main: true,
  procurement: false,
  auction: false,
};

const SidebarContext = createContext(
    {
  activeSection: "/",
  setActiveSection: () => {},
  expandedAccordions: defaultExpandedAccordions,
  setExpandedAccordions: () => {},
}
);

const SidebarProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    main: true,
    procurement: false,
    auction: false,
  });

  const value = useMemo(
    () => ({
      activeSection,
      setActiveSection,
      expandedSections,
      setExpandedSections,
    }),
    [activeSection, expandedSections]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export { SidebarContext, SidebarProvider };
